import  { createContext } from 'react';

const HandleRefreshContext = createContext();
const HandleRefreshContextVideo = createContext();
export { HandleRefreshContext, HandleRefreshContextVideo };